import React, { useRef, useState } from "react";
import "./css/RowExpansionTemplate.css";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import moment from "moment";
import { PlanEditIcon } from "../../../../../../../../../../utility";
import { OverlayPanel } from "primereact/overlaypanel";
import { normalizeString } from "../../../../../../../../../../utility/normalizeSentence";
import { LogsAction } from "./LogsAction";

export const RowExpansionTemplate = ({
  setIsVoidDialogActive,
  PaymentLogExpansionRowData,
  setRowData,
  setIsRefundDialogActive,
  cpData,
}) => {
  console.log(PaymentLogExpansionRowData[0]);
  const op = useRef(null);
  const OverlayRef = useRef(null);
  const [overlayContent, setOverlayContent] = useState("");

  return (
    <div className="row-expansion-container">
      <DataTable
        showHeaders={false}
        value={PaymentLogExpansionRowData[0].remaining}
      >
        <Column
          field="invoiceNo"
          header="Invoice No"
          body={(rowData) => (
            <div className="expander-row-invoiceno">
              <i style={{ border: "none !important" }} />
              <p>{rowData?.invoiceNo}</p>
            </div>
          )}
        />

        <Column
          header="Created Date"
          body={(rowData) => {
            return (
              <span>
                {moment(rowData.date)
                  .tz("America/New_York") // Convert to New York time (Eastern Time Zone)
                  .format("MM-DD-YYYY")}
              </span>
            );
          }}
        />
        <Column
          field="invoiceType"
          header="Type"
          body={(rowData) => (
            <>
              <p
                onMouseEnter={(e) => {
                  if (rowData?.invoiceType[0].length > 15) {
                    setOverlayContent(rowData?.invoiceType[0]);
                    OverlayRef.current.show(e);
                  }
                }}
                onMouseLeave={() => OverlayRef.current.hide()}
              >
                {rowData?.invoiceType[0].length > 15
                  ? rowData?.invoiceType[0]?.substring(0, 12) + "..."
                  : rowData.invoiceType[0]}
              </p>
              <OverlayPanel ref={OverlayRef}>
                <div style={{ padding: "0.5rem 1rem" }}>
                  <p
                    style={{
                      fontWeight: 400,
                      fontSize: "1.4rem",
                      overflow: "hidden",
                      border: "none",
                      margin: "0rem",
                      lineHeight: "1.8rem",
                      color: "#72728f",
                    }}
                  >
                    {" "}
                    {normalizeString(overlayContent)}
                  </p>
                </div>
              </OverlayPanel>
            </>
          )}
        />

        <Column
          field="paymentStatus"
          body={(rowData) => {
            const statusText =
              rowData.transactionStatus.charAt(0).toUpperCase() +
              rowData.transactionStatus.slice(1);
            return (
              <>
                <p
                  className={`${rowData.paymentStatus === "failure" ? "status-failure" : "status-success"}`}
                  onMouseEnter={(e) => {
                    if (statusText.length > 12) {
                      setOverlayContent(statusText);
                      OverlayRef.current.show(e);
                    }
                  }}
                  onMouseLeave={() => OverlayRef.current.hide()}
                >
                  {rowData?.transactionStatus
                    ? (() => {
                        const status = normalizeString(
                          rowData.transactionStatus,
                        );

                        return status.length > 12
                          ? `${status.substring(0, 9)}...`
                          : status;
                      })()
                    : "NIL"}
                </p>
                <OverlayPanel ref={OverlayRef}>
                  <div style={{ padding: "0.5rem 1rem" }}>
                    <p
                      style={{
                        fontWeight: 400,
                        fontSize: "1.4rem",
                        overflow: "hidden",
                        border: "none",
                        margin: "0rem",
                        lineHeight: "1.8rem",
                        color: "#72728f",
                      }}
                    >
                      {normalizeString(overlayContent)}
                    </p>
                  </div>
                </OverlayPanel>
              </>
            );
          }}
          header="Status"
        />
        <Column
          field="cardDetails.cardNumber"
          header="Card Details"
          body={(rowData) => {
            return (
              <>
                <p
                  onMouseEnter={(e) => {
                    if (rowData?.cardDetails?.cardNumber?.length > 4) {
                      setOverlayContent(rowData?.cardDetails?.cardNumber);
                      OverlayRef.current.show(e);
                    }
                  }}
                  onMouseLeave={() => OverlayRef.current.hide()}
                >
                  {rowData?.cardDetails?.cardNumber
                    ? rowData?.cardDetails?.cardNumber?.length > 4
                      ? rowData?.cardDetails?.cardNumber?.substring(0, 4) +
                        "..."
                      : rowData?.cardDetails?.cardNumber
                    : "NIL"}
                </p>
                <OverlayPanel ref={OverlayRef}>
                  <div style={{ padding: "0.5rem 1rem" }}>
                    <p
                      style={{
                        fontWeight: 400,
                        fontSize: "1.4rem",
                        overflow: "hidden",
                        border: "none",
                        margin: "0rem",
                        lineHeight: "1.8rem",
                        color: "#72728f",
                      }}
                    >
                      {" "}
                      {overlayContent}
                    </p>
                  </div>
                </OverlayPanel>
              </>
            );
          }}
        />

        <Column
          field="amount"
          header="Amount"
          body={(rowData) =>
            rowData?.amount !== undefined &&
            rowData?.amount !== "NaN" &&
            rowData?.amount !== ""
              ? parseFloat(rowData?.amount).toFixed(2)
              : "0.00"
          }
        />
        <Column
          field="currentBalance"
          header="Current Bill"
          body={(rowData) =>
            rowData?.currentBalance !== undefined &&
            rowData?.currentBalance !== "NaN" &&
            rowData?.currentBalance !== ""
              ? parseFloat(rowData?.currentBalance).toFixed(2)
              : "0.00"
          }
        />
        <Column
          field="previousBalance"
          body={(rowData) =>
            rowData?.previousBalance !== undefined &&
            rowData?.previousBalance !== "NaN" &&
            rowData?.previousBalance !== ""
              ? parseFloat(rowData?.previousBalance).toFixed(2)
              : "0.00"
          }
          header="Previous Balance"
        />

        <Column
          field="transactionId"
          header="Transaction ID"
          body={(rowData) => {
            return (
              <>
                <p
                  onMouseEnter={(e) => {
                    if (rowData?.transactionId?.length > 23) {
                      setOverlayContent(rowData?.transactionId);
                      OverlayRef.current.show(e);
                    }
                  }}
                  onMouseLeave={() => OverlayRef.current.hide()}
                >
                  {rowData?.transactionId
                    ? rowData?.transactionId?.length > 23
                      ? rowData?.transactionId?.substring(0, 22) + "..."
                      : rowData?.transactionId
                    : "NIL"}
                </p>
                <OverlayPanel ref={OverlayRef}>
                  <div style={{ padding: "0.5rem 1rem" }}>
                    <p
                      style={{
                        fontWeight: 400,
                        fontSize: "1.4rem",
                        overflow: "hidden",
                        border: "none",
                        margin: "0rem",
                        lineHeight: "1.8rem",
                        color: "#72728f",
                      }}
                    >
                      {overlayContent}
                    </p>
                  </div>
                </OverlayPanel>
              </>
            );
          }}
        />
        <Column
          field="Actions"
          header="Actions"
          body={(rowData) => (
            <LogsAction
              rowData={rowData}
              setRowData={setRowData}
              setIsRefundDialogActive={setIsRefundDialogActive}
              setIsVoidDialogActive={setIsVoidDialogActive}
            />
          )}
        />
      </DataTable>
    </div>
  );
};
